import { react, useState, useEffect } from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const Question = ({
  questionIndex,
  module,
  question,
  options,
  setQuestionAnswer,
  correctAnswer,
  explanation,
  submitted_answer,
  quizSubmitted,
  bookmarkedQuestions,
  toggleBookmark
}) => {
  const [selectedOption, setSelectedOption] = useState(`${questionIndex}`);
  useEffect(() => {
    if (submitted_answer !== null) {
      const reverseIndex = ["a", "b", "c", "d", "_"];
      const correctIndex = reverseIndex.indexOf(submitted_answer);

      setSelectedOption(correctIndex);
    }
  }, [questionIndex]);

  return (
    <MDBox m={5}>
      <MDTypography variant="h5">
        {questionIndex + 1}. {question}
      </MDTypography>
      {options.map((option, index) => (
        <MDBox
          key={`${questionIndex}_${index}`}
          my={3}
        >
          <input
            type="radio"
            id={`${questionIndex}_${index}`}
            name={`${questionIndex}`}
            value={option}
            checked={selectedOption === index}
            onChange={() => setSelectedOption(index)}
            disabled={quizSubmitted}
          />
          &nbsp;&nbsp;
          <label htmlFor={`${questionIndex}_${index}`}>{option}</label>
        </MDBox>
      ))}
      <MDBox display="flex" alignItems="center" my={2} gap={2}>
        <MDButton
          variant="contained"
          color="info"
          disabled={quizSubmitted || selectedOption === null || selectedOption === 4}
          onClick={() => setQuestionAnswer(selectedOption)}
        >
          Submit Answer
        </MDButton>
        <MDButton
          variant="contained"
          color="warning"
          onClick={() => toggleBookmark(questionIndex)}
          disabled={quizSubmitted}
        >
          {bookmarkedQuestions.includes(questionIndex) ? "Remove Bookmark" : "Bookmark Question"}
        </MDButton>

      </MDBox>
      {correctAnswer && (
        <MDTypography variant="h6" mt={3}>
          Correct Answer: {correctAnswer}
        </MDTypography>
      )}
      {explanation && (
        <MDTypography variant="body1" my={2}>Explanation: {explanation}</MDTypography>
      )}
    </MDBox>
  );
};

export default Question;
